import {
  Component,
  OnInit,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Inject,
  Input,
  TemplateRef,
  ViewChild,
  AfterViewInit
} from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatPaginator } from '@angular/material/paginator';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatTableDataSource } from '@angular/material/table';
import {
  Answers,
  Answers_Pk_Columns_Input,
  Answers_Set_Input,
  Results,
  DatasService,
  GetAnswersByProfileIdGQL,
  GetAnswersGQL,
  GetSupportByPkGQL,
  Supports,
  GetLightAnswersByResultIdGQL
} from '@polylearn/models';
import { examData } from 'apps/landing/src/ng1/www/examData';
import { reverse, sortBy, sum } from 'lodash';
import { BehaviorSubject, combineLatest, from, Observable } from 'rxjs';
import { tap, flatMap, map } from 'rxjs/operators';
import { DialogService } from '../../ui/dialog/dialog.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'polylearn-manual-correction',
  templateUrl: './manual-correction.component.html',
  styleUrls: ['./manual-correction.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ManualCorrectionComponent implements OnInit, AfterViewInit {
  @ViewChild(MatPaginator, { static: false }) paginator: MatPaginator;

  @Input() role: 'user' | 'teacher';

  displayedColumns: string[];

  answers$: Observable<Answers[]>;
  displayedAnswers$: Observable<Answers[]>;

  updateAnswers$ = new BehaviorSubject(null);
  /*
  editAnswersForm: FormGroup = this.fb.group({
    id: null,
    name: [null, [Validators.required]],
    credits: [null, [Validators.required]],
    logo: null,
    slug: null,
    credit_duration: [null, Validators.required],
  });
  */

  editAnswersForm: FormGroup = this.fb.group({
    feedback: null,
    feedback_by: null,
    feedback_at: null,
    feedback_score: [
      null,
      [Validators.min(0), Validators.max(25), Validators.required]
    ]
  });

  support$: Observable<Supports>;
  updateSupport = new BehaviorSubject<number>(null);

  selectedAnswer: Answers;

  actions = [
    /*
    {
      text: 'Voir la correction',
      icon: 'edit',
      click: (element: Answers) => {
        /*
        this.dialogService.prompt({
          title: 'Changer le nombre de licences'
        }, {
          type: 'number',
          label: 'Nombre de licences',
          value: element.credits
        }).subscribe(
          res => {
            if (res) {
              this.dataService.updateData$<Institutions>('institutions', element.id,  {
                credits: parseInt(res, 10)
              }, 'id').subscribe(r => {
                this._snackBar.open('Updaed', null, {
                  duration: 5000
                });
                this.updateAnswers$.next(null);
              });
            }
          }
        );

      }
    },
    {
      text: 'Éditer la correction',
      icon: 'edit',
      click: (element: Answers) => {
        /*
        this.dialogService.prompt({
          title: 'Changer le nombre de licences'
        }, {
          type: 'number',
          label: 'Nombre de licences',
          value: element.credits
        }).subscribe(
          res => {
            if (res) {
              this.dataService.updateData$<Institutions>('institutions', element.id,  {
                credits: parseInt(res, 10)
              }, 'id').subscribe(r => {
                this._snackBar.open('Updaed', null, {
                  duration: 5000
                });
                this.updateAnswers$.next(null);
              });
            }
          }
        );

      }
    },*/
  ];

  dataSource;
  angularJsAPI: any;

  activeTab$ = new BehaviorSubject<string>(null);
  tabs: any;

  constructor(
    private dialogService: DialogService,
    private dataService: DatasService,
    private _snackBar: MatSnackBar,
    private fb: FormBuilder,
    private cd: ChangeDetectorRef,
    private getAnswersGQL: GetAnswersGQL,
    private getAnswersByProfileIdGQL: GetAnswersByProfileIdGQL,
    private getSupportByPkGQL: GetSupportByPkGQL,
    private getLightAnswersByResultId: GetLightAnswersByResultIdGQL,
    private translate: TranslateService,
    @Inject('api') api: any
  ) {
    this.angularJsAPI = api;
  }

  ngOnInit(): void {
    console.log('role', this.role);

    if (this.role === 'user') {
      this.displayedColumns = [
        'created_at',
        'is_mock',
        'feedback_at',
        'level',
        'score',
        'part',
        'actions'
      ];
      this.tabs = [
        {
          label: 'corrected',
          value: 'corrected'
        },
        {
          label: 'not_corrected',
          value: 'not_corrected'
        }
      ];
      this.activeTab$.next('corrected');
    } else {
      this.displayedColumns = [
        'created_at',
        'is_mock',
        'feedback_at',
        'student',
        'level',
        'score',
        'part',
        'actions'
      ];
      this.tabs = [
        {
          label: 'to_correct',
          value: 'not_corrected'
        },
        {
          label: 'corrected',
          value: 'corrected'
        }
      ];

      this.activeTab$.next('not_corrected');
    }

    this.support$ = this.updateSupport.pipe(
      flatMap(supportId => {
        return this.getSupportByPkGQL
          .fetch(
            {
              id: supportId
            },
            {
              fetchPolicy: 'no-cache',
              context: {
                headers: {
                  role: this.role
                }
              }
            }
          )
          .pipe(map(res => (res.data.supports_by_pk as any) as Supports));
      })
    );

    this.answers$ = this.updateAnswers$.pipe(
      flatMap(() => {
        let supportParts = [7, 8, 9, 10, 11, 12];
        let exam = 'delf';

        if (this.role === 'user') {
          return this.getAnswersByProfileIdGQL.fetch(
            {
              exam,
              supportParts,
              profileId: this.angularJsAPI.data.me.profile.id
            },
            {
              fetchPolicy: 'no-cache',
              context: {
                headers: {
                  role: 'user'
                }
              }
            }
          );
        } else if (this.role === 'teacher') {
          return from(this.angularJsAPI.getStudentRestrictionData()).pipe(
            flatMap(profileIds => {
              return this.getAnswersGQL.fetch(
                {
                  exam,
                  supportParts,
                  institutionId: this.angularJsAPI.data.me.institution.id,
                  profileIds: profileIds as number[]
                },
                {
                  fetchPolicy: 'no-cache',
                  context: {
                    headers: {
                      role: 'teacher'
                    }
                  }
                }
              );
            })
          );
        }
      }),
      map(res => (res.data.answers as any) as Answers[]),
      map(datas => {
        return datas.filter(
          data => (data.is_mock && data.result_id) || !data.is_mock
        );
      })
    );

    this.displayedAnswers$ = combineLatest(this.answers$, this.activeTab$).pipe(
      map(([answers, activeTab]) => {
        if (!activeTab) {
          return [];
        }

        return answers.filter(answer => {
          if (activeTab === 'corrected') {
            return answer.feedback_at;
          }

          return !answer.feedback_at;
        });
      }),
      tap(res => {
        setTimeout(() => {
          this.dataSource = new MatTableDataSource(
            reverse(sortBy(res, r => r.created_at))
          );
          this.dataSource.paginator = this.paginator;
          this.cd.detectChanges();
        });
      })
    );
  }

  ngAfterViewInit() {}

  trackByMethod(index: number, el: any): number {
    return index;
  }

  public async openAddOrgDialog(
    templateRef: TemplateRef<any>,
    footerTemplateRef: TemplateRef<any>,
    answer: Answers
  ) {
    let title = this.translate.instant('manual_correction.correction');

    this.updateSupport.next(answer.question.support.id);

    this.selectedAnswer = answer;

    this.editAnswersForm.patchValue({
      feedback: answer.feedback,
      feedback_by: this.angularJsAPI.data.me.profile.id,
      feedback_at: new Date().toISOString(),
      feedback_score: answer.feedback_score
    });

    this.dialogService
      .custom(
        {
          title: title,
          matDialogConfig: {
            width: '1280px'
          }
        },
        {
          footer: footerTemplateRef,
          content: templateRef
        }
      )
      .subscribe(res => {
        console.log(res);
        if (res) {
          console.log('answ', answer);
          this.dataService
            .updateData$<Answers>(
              'answers',
              'teacher',
              answer.id,
              {
                ...this.editAnswersForm.value
              },
              'id'
            )
            .subscribe(
              async r => {
                if (answer.result_id) {
                  this._updateResult(answer);
                }
                setTimeout(() => {
                  this.updateAnswers$.next('update');
                }, 300);
                this._snackBar.open(
                  `La correction a bien été sauvegardé`,
                  null,
                  {
                    duration: 5000
                  }
                );
              },
              err => {
                this._snackBar.open(`Une erreur est survenue`, null, {
                  duration: 5000
                });
              }
            );
        }
      });
  }

  public getPart(partId: number, level: string) {
    let parts = examData.delf.part.sections[0]?.parts;

    return parts.find(p => p.id === partId && level === p.level);
  }

  private async _updateResult(answer: Answers) {
    let answers = await this.getLightAnswersByResultId
      .fetch(
        { resultId: answer.result_id },
        {
          fetchPolicy: 'no-cache',
          context: {
            headers: {
              role: this.role
            }
          }
        }
      )
      .pipe(map(res => (res.data.answers as any) as Answers[]))
      .toPromise();

    let partId = answer.question.support.part;
    let level = answer.question.support.exam.level;
    let currentScoreFromAnswer = parseInt(
      this.editAnswersForm.value.feedback_score,
      10
    );

    let part = this.getPart(partId, level);
    let key = part.score;

    let answersFromSameType = answers.filter(a => {
      if (answer.id === a.id) {
        return false;
      }

      return this.getPart(a.part, level)?.score === key;
    });

    let scores = [
      ...answersFromSameType.map(a => a.feedback_score)?.filter(s => s),
      currentScoreFromAnswer
    ];

    let totalScoreForThisCategory = sum(scores);

    let globalScores = [
      answer?.result?.oral_score,
      answer?.result?.listening_score,
      answer?.result?.writing_score,
      answer?.result?.reading_score
    ];

    if (key === 'oral_score') {
      globalScores[0] = totalScoreForThisCategory;
    } else if (key === 'writing_score') {
      globalScores[2] = totalScoreForThisCategory;
    }

    console.log('globalScores', globalScores);

    let score = globalScores
      .filter(s => s !== null)
      .reduce((acc, cur) => acc + cur, 0);

    let data = {};
    data[key] = totalScoreForThisCategory;

    this.dataService
      .updateData$<Results>(
        'results',
        'teacher',
        answer.result_id,
        {
          ...data,
          score
        },
        'id'
      )
      .subscribe(
        async r => {},
        err => {
          this._snackBar.open(`Une erreur est survenue`, null, {
            duration: 5000
          });
        }
      );
  }
}
